<template>
	<v-container
		px-0
		grid-list-md
	>
		<v-form
			ref="reprintsForm"
			v-model="valid"
			@submit.prevent="submit(false)"
		>
			<div class="title">
				<slot name="title">Add Reprints</slot>
			</div>
			<div style="position: relative;">
				<div>
					<v-textarea
						v-model="urls"
						:rules="[validate.urlRules, ...validate.require]"
						:required="true"
						autofocus
						name="url"
						label="Add URLs (1 per line) *"
					/>
				</div>
			</div>
			<v-divider class="my-3" />
			<div class="text-xs-center">
				<v-btn
					:disabled="!valid"
					type="submit"
					ripple
					class="primary"
				>
					Submit
				</v-btn>
				<v-btn
					v-if="closable"
					color="error"
					@click="$emit('close')"
				>
					Close
				</v-btn>
			</div>
		</v-form>
	</v-container>
</template>


<script>
import Validation from '@/mixins/Validation';
import AddArticle from '@/components/Article/AddArticle';
import { Article } from '@/models/Article';

export default {
	components: {
		AddArticle,
	},
	props: {
		item: { type: Article, required: true },
		loadable: { type: Boolean, default: true },
		closable: { type: Boolean, default: false },
	},
	mixins: [Validation],
	data() {
		return {
			valid: false,
			urls: '',
			externalURL: '',
			imageUploadActive: false,
			urlFormValid: false,
		};
	},
	methods: {
		submit() {
			if (this.validateURLS()) {
				// remove false items (whitespace) from url list
				const urls = this.urls.split(' ').join('\n').split('\n').filter(Boolean);
				this.addReprints(urls);
				this.$refs.reprintsForm.reset();
			}
		},
		addReprints(urlsList) {
			const processingURLs = this.removeDuplicateURLS(urlsList);
			const reports = this.reports;
			this.loading = true;
			this.loadingProgress = 0;
			this.errorItems = [];
			this.addedItems = [];
			this.urlCount = processingURLs.length;
			const urls = this.filterExistingURLs(processingURLs);

			// If all of the articles added already exist in the report we are done
			if (urls.length === 0) {
				this.loading = false;
				return;
			}
			
			this.item.addReprints(urls);
		},
		removeDuplicateURLS(urls) {
			return urls.filter((item, pos, self) => self.indexOf(item) === pos);
		},
		// method to filter out urls that already exists in this.item.reprints
		filterExistingURLs(urls) {
			const existingURLs = this.item.reprints.map(item => item.url);
			return urls.filter((item) => !existingURLs.includes(item));
		},
	},
};
</script>
